<div class="opciones">
  <div class="col-md-12">
    <p>
      Correos de atención:
    </p>
  </div>
  <div class="col-md-12 pd10" *ngFor="let correo of correos">
    <div class="col-sm-6">
      <label>{{correo}}</label>
    </div>
    <div class="col-sm-6">
      <button mat-raised-button color="primary" (click)= "copyToClipboard(correo)">Copiar <mat-icon>
          file_copy</mat-icon></button>
    </div>
  </div>


</div>

